var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view schedules"},[_c('v-container',{staticClass:"mt-2",style:('width: 100%; position: relative;')},[_c('h1',{staticClass:"mb-10"},[_vm._v("F2F Metting administration")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }